import { Injectable, EventEmitter } from "@angular/core";

export interface AppPage {
  title: string;
  url: string;
  icon: string;
  menuItem: boolean;
  open: boolean;
  children: AppPage[];
}

@Injectable({
  providedIn: "root",
})
export class AppHeaderService {
  appPages: AppPage[] = [
    {
      title: "Home",
      url: "/home",
      icon: "home-outline",
      menuItem: true,
      open: false,
      children: [],
    },
    {
      title: "Training",
      url: "/training",
      icon: "desktop-outline",
      menuItem: true,
      open: false,
      children: [],
    },
    {
      title: "Users",
      url: "/users",
      icon: "people-outline",
      menuItem: true,
      open: false,
      children: [
        {
          title: "Manage users",
          url: "/peopleSimplified",
          icon: "people-outline",
          menuItem: true,
          open: false,
          children: [],
        },
        {
          title: "Import list of users",
          url: "/importPeople",
          icon: "download-outline",
          menuItem: true,
          open: false,
          children: [],
        },
        {
          title: "Clicker groups",
          url: "/peopleGroups",
          icon: "people-circle-outline",
          menuItem: true,
          open: false,
          children: [],
        },
        {
          title: "Open sessions",
          url: "/end-session",
          icon: "options",
          menuItem: true,
          open: false,
          children: [],
        },
        {
          title: "Assign sites",
          url: "/siteAssignment",
          icon: "locate-outline",
          menuItem: true,
          open: false,
          children: [],
        },
      ],
    },
    {
      title: "Lessons",
      url: "/lesson-builder",
      icon: "library-outline",
      menuItem: true,
      open: false,
      children: [
        {
          title: "Manage lessons",
          url: "/lessons",
          icon: "library-outline",
          menuItem: true,
          open: false,
          children: [],
        },
        {
          title: "Manage courses",
          url: "/qualifications",
          icon: "school-outline",
          menuItem: true,
          open: false,
          children: [],
        },

        // {
        //   title: "Upload media",
        //   url: "/media",
        //   icon: "images",
        //   menuItem: true,
        //   open: false,
        //   children: [],
        // },
        {
          title: "Manage procedures",
          url: "/procedure-manager",
          icon: "clipboard-outline",
          menuItem: true,
          open: false,
          children: [
            {
              title: "Create procedures",
              url: "/procedure",
              icon: "create",
              menuItem: true,
              open: false,
              children: [],
            },
            {
              title: "Procedures completed",
              url: "/procedureSigned",
              icon: "copy",
              menuItem: true,
              open: false,
              children: [],
            },
          ],
        },
        {
          title: "Assign multiple lessons",
          url: "/assignments",
          icon: "git-merge-outline",
          menuItem: true,
          open: false,
          children: [],
        },
      ],
    },
    {
      title: "Manage content",
      url: "/manage-content",
      icon: "images-outline",
      menuItem: true,
      open: false,
      children: [],
    },
    // {
    //   title: "Contractors",
    //   url: "/resource-manager",
    //   icon: "briefcase-outline",
    //   menuItem: true,
    //   open: false,
    //   children: [
    //     {
    //       title: "Manage contractors",
    //       url: "/contractor",
    //       icon: "briefcase-outline",
    //       menuItem: true,
    //       open: false,
    //       children: [],
    //     },
    //     {
    //       title: "Contractor employees",
    //       url: "/people",
    //       icon: "people-outline",
    //       menuItem: true,
    //       open: false,
    //       children: [],
    //     },
    //     {
    //       title: "Contractor configuration",
    //       url: "/contractor-config",
    //       icon: "construct-outline",
    //       menuItem: true,
    //       open: false,
    //       children: [
    //         {
    //           title: "Ethnicities",
    //           url: "/race",
    //           icon: "build",
    //           menuItem: true,
    //           open: false,
    //           children: [],
    //         },
    //         {
    //           title: "Housing statuses",
    //           url: "/housingStatus",
    //           icon: "home-outline",
    //           menuItem: true,
    //           open: false,
    //           children: [],
    //         },
    //         {
    //           title: "Work areas",
    //           url: "/workArea",
    //           icon: "build",
    //           menuItem: true,
    //           open: false,
    //           children: [],
    //         },
    //         {
    //           title: "Mine rental types",
    //           url: "/mineRentalType",
    //           icon: "build",
    //           menuItem: true,
    //           open: false,
    //           children: [],
    //         },
    //         {
    //           title: "Work schedules",
    //           url: "/workSchedule",
    //           icon: "build",
    //           menuItem: true,
    //           open: false,
    //           children: [],
    //         },
    //         {
    //           title: "Village",
    //           url: "/village",
    //           icon: "storefront-outline",
    //           menuItem: true,
    //           open: false,
    //           children: [],
    //         },
    //         {
    //           title: "Geographical regions",
    //           url: "/regions",
    //           icon: "build",
    //           menuItem: true,
    //           open: false,
    //           children: [],
    //         },
    //         {
    //           title: "Distribution lists",
    //           url: "/distributionList",
    //           icon: "construct",
    //           menuItem: true,
    //           open: false,
    //           children: [],
    //         },
    //       ],
    //     },
    //     {
    //       title: "Vehicles",
    //       url: "/vehicle",
    //       icon: "car",
    //       menuItem: true,
    //       open: false,
    //       children: [],
    //     },
    //     {
    //       title: "Equipment",
    //       url: "/equipment",
    //       icon: "construct",
    //       menuItem: true,
    //       open: false,
    //       children: [],
    //     },

    //     {
    //       title: "Scope of work",
    //       url: "/sow",
    //       icon: "file-tray-full-outline",
    //       menuItem: true,
    //       open: false,
    //       children: [],
    //     },
    //   ],
    // },
    {
      title: "Visitors",
      url: "/visitors",
      icon: "walk-outline",
      menuItem: true,
      open: false,
      children: [],
    },
    {
      title: "Site configuration",
      url: "/profile",
      icon: "settings-outline",
      menuItem: true,
      open: false,
      children: [
        // {
        //   title: "Licensing",
        //   url: "/license",
        //   icon: "card",
        //   menuItem: true,
        //   children: [],
        // },
        // {
        //   title: "Price Plans",
        //   url: "/pricePlan",
        //   icon: "logo-usd",
        //   menuItem: true,
        //   children: [],
        // },
        // {
        //   title: "Subscription",
        //   url: "/subscription",
        //   icon: "logo-buffer",
        //   menuItem: true,
        //   children: [],
        // },
        // {
        //   title: "Configuration",
        //   url: "/configuration",
        //   icon: "build",
        //   menuItem: true,
        //   children: [],
        // },
        {
          title: "Data lists",
          url: "datalists",
          icon: "list-outline",
          menuItem: true,
          open: false,
          children: [
            {
              title: "Department",
              url: "/department",
              icon: "git-network-outline",
              menuItem: true,
              open: false,
              children: [],
            },
            {
              title: "Occupation",
              url: "/jobTitle",
              icon: "build",
              menuItem: true,
              open: false,
              children: [],
            },

            {
              title: "Sites",
              url: "/site",
              icon: "build",
              menuItem: true,
              open: false,
              children: [],
            },
            {
              title: "Titles",
              url: "/title",
              icon: "build",
              menuItem: true,
              open: false,
              children: [],
            },
          ],
        },
      ],
    },
    {
      title: "Reports",
      url: "/administration",
      icon: "receipt-outline",
      menuItem: true,
      open: false,
      children: [
        {
          title: "User reports",
          url: "/report",
          icon: "receipt-outline",
          menuItem: true,
          open: false,
          children: [],
        },
        // {
        //   title: "User metrics",
        //   url: "/userMetrics",
        //   icon: "reader-outline",
        //   menuItem: true,
        //   open: false,
        //   children: [],
        // },

        // {
        //   title: "Lesson metrics",
        //   url: "/lessonMetrics",
        //   icon: "pie-chart-outline",
        //   menuItem: true,
        //   open: false,
        //   children: [],
        // },
        // {
        //   title: "Site metrics",
        //   url: "/siteMetrics",
        //   icon: "bar-chart-outline",
        //   menuItem: true,
        //   open: false,
        //   children: [],
        // },
        // {
        //   title: "Group metrics",
        //   url: "/groupMetrics",
        //   icon: "stats-chart-outline",
        //   menuItem: true,
        //   open: false,
        //   children: [],
        // },
        {
          title: "RegistrationFinalization",
          url: "/registrationFinalization",
          icon: "registrationFinalization",
          menuItem: false,
          open: false,
          children: [],
        },
        {
          title: "LicenseFinalization",
          url: "/licenseFinalization",
          icon: "licenseFinalization",
          menuItem: false,
          open: false,
          children: [],
        },
      ],
    },
    {
      title: "Resources",
      url: "/resources",
      icon: "easel-outline",
      menuItem: true,
      open: false,
      children: [],
    },
  ];

  appHeaderEmitter: EventEmitter<string> = new EventEmitter();
  selectedPage: AppPage;

  constructor() {}

  getSelectedPages() {
    return this.selectedPage;
  }
  setByUrl(url: string) {
    console.log("changing url : " + url + " @ " + new Date());

    this.appHeaderEmitter.emit(url);
  }
}
